import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

import { ReactComponent as CheckSvg } from '@/assets/icons/check-icon.svg';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    padding: ${theme.spacing(1, 2)};
  `}
`;

export const CheckIcon = styled(CheckSvg)`
  margin-right: ${({ theme }) => theme.spacing(1)};
  position: absolute;
  right: -10px;
  top: 0;
  color: ${({ theme }) => theme.colors.primaryBlue};
  && {
    width: 24px;
    height: 24px;
  }
`;

export const ImageWrapper = styled(Box)<{ $showCheckIcon?: boolean }>`
  position: relative;
  width: 76px;
  height: 46px;
  display: flex;
  justify-content: end;
  align-items: start;
  ${({ $showCheckIcon, theme }) => css`
    padding-top: ${theme.spacing($showCheckIcon ? 1 : 0)};
    padding-right: ${theme.spacing(1.5)};
  `}
  svg {
    height: 40px;
  }
`;

export const MessageWrapper = styled(Box)<{ $showCheckIcon?: boolean }>`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  ${({ $showCheckIcon, theme }) => css`
    padding-top: ${theme.spacing($showCheckIcon ? 0.5 : 0)};
    padding-left: ${theme.spacing(2)};
  `}
`;

export const Item = styled(Flex)`
  ${({ theme }) => css`
    padding: ${theme.spacing(1, 0)};
  `}
`;
